export default () => ({
  root: { marginBottom: '1.75rem' },
});
